<template>
  <div class="support-ticket-container">
    <header class="support-ticket-header">
      <div class="d-flex w-100 align-items-center justify-content-between">
        <div>
          <img src="@/assets/img/logos/logo-dark.png" width="85" />
        </div>
        <router-link class="btn-outline-blue" to="/mobile-support-ticketing">Support Ticket List</router-link>
      </div>
    </header>

    <!-- <router-link class="btn-link" to="/mobile-support-ticketing">Back</router-link> -->

    <div class="section-title text-center mb-4">{{ $t('respond') }} {{ $t('supportticketing') }}</div>

    <div class="row support-ticket-additionl-details">
      <div class="col-12">
        <label class="mb-1">Ticket Query</label>
        <h5 class="mb-4">Order New Cups Existing one are damager</h5>
      </div>
      <div class="col-6">
        <label class="mb-1">Category</label>
        <p>{{ selectedcategory }}</p>
      </div>
      <div class="col-6">
        <label class="mb-1">Ticket raised on:</label>
        <p>{{ TicketListByID_IsFirst[0].created_at | dateparse }}</p>
      </div>

      <div class="col-6">
        <label class="mb-1">Submitted by:</label>
        <p>{{ selecteduser }}</p>
      </div>

      <div class="col-6">
        <label class="mb-1">Status</label>
        <p>
          <b-form-checkbox
            v-model="st_is_active"
            :disabled="statusenable"
            name="check-button"
            switch
          ></b-form-checkbox>
        </p>
      </div>

      <div class="col-lg-12 col-xl-12 mb-4">
          <div
            class="column"
            v-for="(images, imagesIndex) in TicketListByID_IsFirst[0].UploadedImages"
            :key="imagesIndex"
          >
            <img :src="_GetImagePath(images)" alt />
          </div>
        </div>

      <!-- <div class="col-12">
        <label class="mb-1">Description:</label> -->
        <!-- <p>{{ticket_description}}</p> -->
        <!-- <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Debitis, consequatur delectus. Hic harum illum, nihil iste sequi asperiores aliquid esse, debitis dolore, iusto tempore magni qui quibusdam et? Iusto, magni.</p>
      </div> -->

      <div v-if="TicketListByID_IsFirst.length > 0" class="col-12 p-3 border-bottom">
        <label class="mb-2">Ticket Responses:</label>
        <div class="row">
          <div class="col-1 pr-0">
            <img src="@/assets/img/icons/user-male.svg" class="img-fluid" />
          </div>
          <div class="col-11">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <strong>{{ TicketListByID_IsFirst[0].first_name }} {{ TicketListByID_IsFirst[0].middle_name }} {{ TicketListByID_IsFirst[0].last_name }}</strong>
              <small>{{ TicketListByID_IsFirst[0].created_at | dateparse }}</small>
            </div>
            <p class="mb-0">{{ TicketListByID_IsFirst[0].stm_comment }}</p>
          </div>
        </div>
      </div>

      <div
        :key="submsgIndex"
        class="col-12 p-3 border-bottom"
        v-if="TicketListByID_SubMsgs.length > 0"
        v-for="(submsg, submsgIndex) in TicketListByID_SubMsgs"
      >
        <div class="row">
          <div class="col-1 pr-0">
            <img src="@/assets/img/icons/user-male.svg" class="img-fluid" />
          </div>
          <div class="col-11">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <strong>{{ submsg.first_name }} {{ submsg.middle_name }} {{ submsg.last_name }}</strong>
              <small>{{ submsg.created_at | dateparse }}</small>
            </div>
            <p class="mb-0">{{ submsg.stm_comment }}</p>
          </div>
        </div>
      </div>

      <div class="col-12 py-3">
        <textarea rows="3"  :disabled="statusenable" v-model="ticket_description" class="form-control mb-3" placeholder="Your Response"></textarea>
        <!-- <button class="btn btn-blue w-100 mx-0">Submit</button> -->
         <div class="row">
           <div class="col-6">
         <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit('Open')"
            class="btn-blue"
          >Submit as Open</button>
           </div>
           <div class="col-6">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit('Close')"
            class="btn-blue"
          >Submit as Close</button>
           </div>
         </div>
      </div>
    </div>

    <!-- <div class="pl-5 py-4 border-bottom">
      <div class="d-flex">
        <img src="@/assets/img/icons/user-male.svg" height="28" width="28" />
        <div class="pl-2 w-100">
          <h3 class="mb-0">{{ submsg.first_name }} {{ submsg.middle_name }} {{ submsg.last_name }}</h3>
          <small>{{ submsg.created_at | dateparse }}</small>
          <div class="msg-box p-2">
            <p>{{ submsg.stm_comment }}</p>
          </div>
        </div>
      </div>
    </div>-->

    <div class="white-wrapper d-none">
      <div class="row">
        <div class="col-lg-4 col-xl-2 mb-4">
          <!-- <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="selecteduser && selecteduser.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('user', 1) }}</label>
              <b-dropdown
                :disabled="isUserID"
                :text="selecteduser"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(user, userIndex) in Users"
                  :key="userIndex"
                  v-on:click="OnSelect('user', $event, user)"
                >{{ user.first_name }} {{ user.middle_name }} {{ user.last_name }}</b-dropdown-item>
              </b-dropdown>
            </div>

            <Tooltip :title="$t('supportticket_user')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selecteduser.length == 0">Please Select User.</span>
          </p>-->
        </div>

        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="input-material">
            <!-- <input placeholder="." disabled /> -->
            <label>Support Ticket Category :-</label>
          </div>
          <!-- <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <label
                :class="selectedcategory && selectedcategory.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('category', 1) }}</label>
              <b-dropdown disabled :text="selectedcategory" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  href="#"
                  v-for="(category, categoryIndex) in TicketCategoryList"
                  :key="categoryIndex"
                  v-on:click="OnSelect('category', $event, category)"
                >{{ category.stc_name }}</b-dropdown-item>
              </b-dropdown>
            </div>

            <Tooltip :title="$t('supportticket_category')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedcategory.length == 0">Please Select Category.</span>
          </p>-->
        </div>

        <div class="col-lg-12 col-xl-12 mb-4">
          <div class="d-flex">
            <div class="input-material-textarea">
              <textarea
                :disabled="statusenable"
                v-model="ticket_description"
                rows="5"
                v-validate="'required'"
                type="text"
                placeholder="Description"
                name="description"
                id="description"
                class="rounded-10"
              ></textarea>
              <!-- <label
                :class="ticket_description && ticket_description.length > 0 ? 'shift-up' : '' "
              >{{ $t('description') }}</label>-->
            </div>
          </div>
          <p v-if="submitted && errors.has('description')" class="error_message">
            <span>{{ errors.first("description")}}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t('active') }}</label>
            <b-form-checkbox
              v-model="st_is_active"
              :disabled="statusenable"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit('Open')"
            class="btn-blue"
          >Submit as Open</button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit('Close')"
            class="btn-blue"
          >Submit as Close</button>

          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/mobile-support-ticketing"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import "@/assets/css/supportTicket.css";
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      submitted: false,
      isUserID: true,
      Cinemas: [],
      status: null,
      statusenable: true,

      cine_id: null,
      selectedcinema: "",
      user_id: null,
      selecteduser: "",
      category_id: null,
      selectedcategory: "",
      ticket_subject: "",
      ticket_description: "",
      st_is_active: true,
      TicketCategoryList: [],
      Users: [],
      stID: null,
      TicketListByID_IsFirst: [],
      TicketListByID_SubMsgs: []
    };
  },
  beforeMount() {
    this.stID = this.$route.query.id;
    this.status = this.$route.query.status;
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.user_id = this.secureStore.get("USINFO").user_id;

    this.selecteduser =
      this.secureStore.get("USINFO").first_name +
        " " +
        this.secureStore.get("USINFO").middle_name &&
      this.secureStore.get("USINFO").middle_name != null
        ? this.secureStore.get("USINFO").middle_name
        : this.secureStore.get("USINFO").first_name +
          " " +
          this.secureStore.get("USINFO").last_name;

    if (true) {
      this.isRoleID = false;
    }

    if (this.status == "Unresolved") {
      this.statusenable = false;
      this.btenable = false;
    } else {
      this.statusenable = true;
      this.btenable = true;
    }

    if (this.user_id == 1) {
      this.isUserID = false;
    }
    this.getCinemasList(obj);
    this.getUsersList(obj, this.user_id);
    this.GetAllTicketsByID();
  },
  methods: {
    GetAllTicketsByID: function() {
      let payload = {
        st_id: this.stID
      };
      let loader = this.$loading.show();

      CinemasService.GetTickets(payload)
        .then(response => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              let Obj = data.Records;

              Obj.map(x => {
                if (x.stm_is_first == "Y") {
                  this.TicketListByID_IsFirst.push(x);
                  this.GetSupportTicketCategory(x.stc_id);
                }
              });

              let Obj2 = data.Records2;

              Obj2.map(x => {
                if (x.stm_is_first == "N") {
                  this.TicketListByID_SubMsgs.push(x);
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    getCinemasList: function(cine_id) {
      this.Cinemas = [];
      let payload = {
        tableName: "ms_cinemas",
        cine_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedcinema = x.cine_name;
                this.cine_id = x.cine_id;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    getUsersList: function(cinema_id, user_id) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "users"
      });
      if (cinema_id) {
        body[cinema_id] = cinema_id;
      }
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Users = data.Records;

            this.Users.map(x => {
              if (String(user_id) === String(x.user_id)) {
                this.selecteduser =
                  x.first_name + " " + x.middle_name + " " + x.last_name;
                this.user_id = x.user_id;
              }
            });
          } else {
          }
        })
        .catch(this._CatchError);
    },

    GetSupportTicketCategory: function(id) {
      let payload = {
        limit: null,
        currentPage: null
      };

      MasterService.GetCategory(payload)
        .then(response => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.TicketCategoryList = data.Records;

              this.TicketCategoryList.map(x => {
                if (id == x.stc_id) {
                  this.selectedcategory = x.stc_name;
                  this.category_id = x.stc_id;
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    OnSelect: function(type, event, data) {
      if (type == "cinema") {
        this.selectedcinema = data.cine_name;
        this.cine_id = data.cine_id;
      }
      if (type == "user") {
        this.selecteduser =
          data.first_name + " " + data.middle_name + " " + data.last_name;
        this.user_id = data.user_id;
      }
      if (type == "category") {
        this.selectedcategory = data.stc_name;
        this.category_id = data.stc_id;
      }
    },

    onResetForm: function() {
      this.category_id = null;
      this.ticket_subject = "";
      this.ticket_description = "";
      this.selectedcategory = null;
      this.cine_id = null;
      this.selectedcinema = null;
    },

    OnFinalSubmit: function(flag) {
      this.submitted = true;

      if (this.selecteduser.length == 0) {
        return;
      }
      if (this.selecteduser == null || this.selecteduser.length == 0) {
        return;
      } else {
        this.$validator.validate().then(valid => {
          if (valid) {
            this.btenable = true;
            let payload = {
              st_id: this.stID,
              res_user_id: this.user_id,
              ticket_status: flag,
              description: this.ticket_description,
              category_id: this.category_id,
              is_active: this.st_is_active
            };

            console.log("payload :>> ", payload);

            CinemasService.RespondSupportTicket(payload)
              .then(response => {
                const { data } = response;

                if (data.status) {
                  this.$toasted.show(data.message);

                  this.$router.push({
                    path: "/mobile-support-ticketing"
                  });
                } else {
                  this.btenable = false;
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          }
        });
      }
    }
  }
};
</script>

<style>
.msg-box {
  background-color: #e9ecef;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/mobileSupportTicketComponent/editMobileSupportTicketing.vue